import React, { Component } from 'react';

import TextInput from '../../../../../components/ZUILib/TextInput';
import SelectionTab from '../../../../../components/ZUILib/SelectionTab';
import CheckBox from '../../../../../components/ZUILib/CheckBox';

class AddAddressForm extends Component {
  constructor(props) {
    super(props);
    this.userData = props.userData;
    this.nickName = props.nickName;

    this.lastPincode = props.lastPincode;
    this.optionsSelector = props.optionsSelector || {};
    this.getAddressDetail = props.getAddressDetail;
    this.textIdElements = props.textIdElements;
    this.postalCode = '';
  }

  componentDidMount() {
    this.updateRefsToElements();
  }

  updateRefsToElements = () => {
    const refsData = {
      addressState: this.addressState,
      municipalty: this.municipalty,
      colony: this.colony,
      otherColony: this.otherColony,
    };

    this.props.configRefsElement({ ...refsData });
  }

  handleAllowOnlyDigitDesktop = (e) => {
    const keyCode = e.charCode;
    if ((keyCode < 48 || keyCode > 57)) {
      e.preventDefault();
    }
  }

  render() {
    const isDisableColonyOptions = (colonyOptions) => {
      if ((colonyOptions.length === 1 && colonyOptions[0].value === 'Otra colonia') || colonyOptions.length <= 0) {
        return true;
      }
      return false;
    };

    return (
      <section
        className="gridFormRegisterEvent registerFormContainer"
      >
        <div className="itemForm" style={{ clear: 'both' }}>
          <TextInput
            className="inputMaterial newInput"
            value={this.props.userData && this.props.userData.nickName ? this.props.userData.nickName : ''}
            htmlId="nickName"
            maxlength="30"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label=" Alias de la dirección"
            required="true"
            star="*"
            ref={this.props.setRef}
            onKeyPress={(e) => { this.props.handleAllowOnlyAlpha(e); }}
            onPaste={(e) => { this.props.onPasteFuncOnlyAlpha(e); }} // TODO: Implement, actually not configurated
            onChange={this.props.onChangeEventName}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>

        <div className="itemForm">
          <div className="flexColumn">
            <TextInput
              htmlId="postalCode"
              disabled={this.props.addressSearchLoading}
              className="inputMaterial newInput"
              //value={this.props.lastPincode || this.props.userData.postalCode || ''}
              maxlength="5"
              labelClassName="placeHolderMaterial"
              parentClassName="marginNull"
              label=" Código postal"
              required="true"
              star="*"
              ref={this.props.setRef}
              onBlur={() => this.props.getAddressDetail(this.props.lastPincode || '')}
              onKeyPress={this.handleAllowOnlyDigitDesktop}
              onKeyDown={(e) => { this.props.handleAllowOnlyDigit(e); }}
              isAddressForm={this.props.isWeb ?true : false}
            />
          </div>
          <div className="flexColumn">
            {/* // TODO: Add checkbox for another postalCode */}
            {/* {
              this.props.isWeb &&  <CheckBox displayName="No sé mi código postal" />
            } */}
           
          </div>
        </div>

        <div className="itemForm">
          <SelectionTab
            classname={`${this.props.optionsSelector.length === 1 ? 'withoutSelectorStyle' : ''} ${this.props.isWeb ? 'cSelect cSelectCustom required select-border-none' : 'cSelect cSelectCustom select-border-none'}`}
            dropDownClass={'native-select-custom'}
            style={{ marginBottom: 0 }}
            styleError={{ display: 'inherit' }}
            id="addressState"
            options={this.props.optionsSelector}
            optionCaption={'Estado'}
            optionText={'labelResourceId'}
            optionValue={'value'}
            sortOptions={true}   // eslint-disable-line react/jsx-boolean-value
            disable={this.props.optionsSelector.length <= 0 || this.props.optionsSelector.length === 1 }
            ref={el => this.addressState = el}
            value={this.props.selectedState ? this.props.selectedState : '' || this.props.addressSearchLoading}
            handleSelectedOption={() => { this.props.handleSelectorRefValue('stateOfCountry', this.addressState); }}
            // isSelectDisable = {`${this.props.optionsSelector.length === 1 ? true : false}`}
            required='true'
            star="*"
            isAddressForm={true}
            isWeb={this.props.isWeb}
          />
        </div>

        <div className="itemForm">
          <SelectionTab
            classname={`${this.props.municipaltyOptions.length === 1 ? 'withoutSelectorStyle' : ''} ${this.props.isWeb ? 'cSelect cSelectCustom required select-border-none' : 'cSelect cSelectCustom select-border-none'}`}
            dropDownClass={'native-select-custom'}
            style={{ marginBottom: 0 }}
            styleError={{ display: 'inherit' }}
            id="municipalty"
            options={this.props.municipaltyOptions}
            optionCaption={'Municipio o alcaldía'}
            optionText={'labelResourceId'}
            optionValue={'value'}
            disable={this.props.municipaltyOptions.length <= 0 || this.props.addressSearchLoading || this.props.municipaltyOptions.length === 1}
            ref={el => this.municipalty = el}
            value={this.props.municipaltyName ? this.props.municipaltyName : 'Selecciona un estado'}
            handleSelectedOption={() => { this.props.handleSelectorRefValue('municipalty', this.municipalty); }}
            required='true'
            star="*"
            isAddressForm={true}
            isWeb={this.props.isWeb}
          />
        </div>

        <div className="itemForm">
          <SelectionTab
            id="colony"
            classname={`${this.props.colonyOptions.length === 1 ? 'withoutSelectorStyle' : ''} ${this.props.isWeb ? 'cSelect cSelectCustom required select-border-none' : 'cSelect cSelectCustom select-border-none'}`}
            dropDownClass={'native-select-custom'}
            style={{ marginBottom: 0 }}
            styleError={{ display: 'inherit' }}
            options={this.props.colonyOptions}
            optionCaption={'Colonia o asentamiento'}
            optionText={'labelResourceId'}
            optionValue={'value'}
            value={this.props.colonyId ? this.props.colonyId : ''}
            disable={isDisableColonyOptions(this.props.colonyOptions) || this.props.addressSearchLoading}
            ref={el => (this.colony = el)}
            handleSelectedOption={(e) => {
              this.props.handleSelectorRefValue('colony', this.colony, e);
            }}
            required='true'
            star="*"
            isAddressForm={true}
            isWeb={this.props.isWeb}
          />
        </div>

        {/* {this.props.showOtherColony && <div className="itemForm"> */}
        {(this.props.otherColonyValue || this.props.showOtherColony) && <div className="itemForm">
          <TextInput
            htmlId="otherColony"
            className="inputMaterial newInput"
            value={this.props.otherColonyValue ? this.props.otherColonyValue : ''}
            maxlength="254"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label="Otra colonia"
            required="true"
            star="*"
            ref={this.props.setRef}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>}

        <div className="itemForm">
          <TextInput
            htmlId="city"
            className="inputMaterial newInput"
            value={this.props.userData && this.props.userData.city ? this.props.userData.city : ''}
            maxlength="40"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label="Ciudad"
            required="true"
            star="*"
            ref={this.props.setRef}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>

        <div className="itemForm">
          <TextInput
            htmlId={this.textIdElements.street}
            //value={this.props.userData && this.props.userData.address1 ? this.props.userData.address1 : ''} 
            className="inputMaterial newInput"
            maxlength="150"
            labelClassName="placeHolderMaterial newLabel"
            parentClassName="marginNull"
            label="Calle"
            required="true"
            star="*"
            ref={this.props.setRef}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>

        <div className="itemForm flexRow">
          <div>
            <TextInput
              htmlId={this.textIdElements.outerNumber}
              //value={(this.props.userData && this.props.userData.exteriorNumber) || null}
              className="inputMaterial newInput typeNumber shortInput"
              maxlength="10"
              labelClassName="placeHolderMaterial newLabel"
              parentClassName="marginNull"
              label=" Núm. ext."
              required="true"
              star="*"
              ref={this.props.setRef}
              isAddressForm={this.props.isWeb ?true : false}
            />
          </div>

          <div>
            <TextInput
              htmlId={this.textIdElements.insideNumber}
              //value={(this.props.userData && this.props.userData.interiorNumber) || ''}
              className="inputMaterial newInput typeNumber shortInput"
              maxlength="10"
              labelClassName="placeHolderMaterial newLabel"
              parentClassName="marginNull"
              required="true"
              label=" Núm. int."
              ref={this.props.setRef}
            />
          </div>
        </div>

        <div className="itemForm">
          <TextInput
            htmlId={this.textIdElements.building}
            value={this.props.userData && this.props.userData.building ? this.props.userData.building : ''}className="inputMaterial newInput"
            required="true"
            maxlength="100"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label="Edificio"
            ref={this.props.setRef}
          />
        </div>

        <div>
          <TextInput
            htmlId={this.textIdElements.betweenStreet}
            value={this.props.userData && this.props.userData.address2 ? this.props.userData.address2 : ''}className="inputMaterial newInput"
            maxlength="100"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label=" Entre calle"
            required="true"
            ref={this.props.setRef}
          />
        </div>

        <div>
          <TextInput
            htmlId={this.textIdElements.andStreet}
            value={this.props.userData && this.props.userData.address3 ? this.props.userData.address3 : ''}className="inputMaterial newInput"
            maxlength="100"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label=" Y calle"
            required="true"
            ref={this.props.setRef}
          />
        </div>

        <div className="itemForm">
          <TextInput
            htmlId={this.textIdElements.mobile}
            value={this.props.userData && this.props.userData.cellular ? this.props.userData.cellular : ''}className="inputMaterial newInput typeNumber"
            maxlength="10"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label="Teléfono celular"
            required="true"
            star="*"
            ref={this.props.setRef}
            onKeyDown={(e) => { this.props.handleAllowOnlyDigit(e); }}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>

        <div className="itemForm">
          <TextInput
            htmlId={this.textIdElements.privatePhone}
            maxlength="10"
            value={this.props.codeData && this.props.codeData.phoneNumber}
            className="inputMaterial newInput typeNumber"
            labelClassName="placeHolderMaterial"
            parentClassName="marginNull"
            label="Teléfono particular"
            required="true"
            star="*"
            ref={this.props.setRef}
            onKeyDown={(e) => { this.props.handleAllowOnlyDigit(e); }}
            isAddressForm={this.props.isWeb ?true : false}
          />
        </div>
      </section>
    );
  }
}

export default AddAddressForm;
